export type HeaderMenuSubItem = {
  key: string;
  text: string;
  link: string;
};

export type HeaderMenuItem = {
  key: string;
  text: string;
  link?: string;
  subs?: HeaderMenuSubItem[];
};

export const parseHeaderMenu = (
  value: string | HeaderMenuItem[] | null | undefined,
): HeaderMenuItem[] => {
  if (!value) return [];
  if (Array.isArray(value)) return value;
  if (typeof value !== "string" || !value.trim()) return [];

  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

/** Flatten menu JSON for legacy header nav ({ label, url }). */
export const headerMenuToFlatNav = (
  items: HeaderMenuItem[],
): Array<{ label: string; url: string }> =>
  items.flatMap((item) => {
    if (item.link) {
      return [{ label: item.text, url: item.link }];
    }
    if (item.subs?.length) {
      return item.subs.map((sub) => ({ label: sub.text, url: sub.link }));
    }
    return [{ label: item.text, url: "#" }];
  });

export type HeaderNavLinkItem = {
  key: string;
  label: string;
  url?: string;
  subs?: Array<{ key: string; label: string; url: string }>;
};

/** Menu JSON for default-v2 header (top-level items may have dropdown subs). */
export const headerMenuToNavItems = (items: HeaderMenuItem[]): HeaderNavLinkItem[] =>
  items.map((item) => ({
    key: item.key,
    label: item.text,
    url: item.link,
    subs: item.subs?.map((sub) => ({
      key: sub.key,
      label: sub.text,
      url: sub.link,
    })),
  }));
